<script>
import CandidateList from '@/views/product/components/product-card/composition/components/CandidateList.vue'

export default {
    name: 'CandidateListStructured',
    extends: CandidateList,
    props: {
        showExemption: {
            type: Boolean,
            default: true,
        },
        requireConcentrationRange: {
            type: Boolean,
            default: false,
        },
        highlightCategories: {
            type: Boolean,
            default: true,
        },
        showCategories: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        showConcentrationRangeRequiredMarker() {
            return this.requireConcentrationRange && !this.concentrationRange
        },
        concentrationRangeState() {
            return this.showConcentrationRangeRequiredMarker ? false : null
        },
    },
}
</script>

<template>
    <div class="candidate-list-structured">
        <b-row v-if="compactView">
            <b-col cols="12">
                <ConcentrationRange
                    :read-only="readOnly"
                    :value="concentrationRange"
                    :config="{ data: concentrationRangeOptions }"
                    :apply-warning-class="!requireConcentrationRange"
                    :required="showConcentrationRangeRequiredMarker"
                    :state="concentrationRangeState"
                    @input="onConcentrationRangeChange"
                />
                <template v-if="showCategories">
                    <MaterialCategory
                        :read-only="readOnly"
                        :apply-warning-class="highlightCategories && applyWarningClassForMixtureOrMaterial"
                        :config="properties[types.MATERIAL_CATEGORY]"
                        :value="materialCategory"
                        @input="onMaterialCategoryChange"
                    />
                    <MixtureCategory
                        :read-only="readOnly"
                        :config="properties[types.MIXTURE_CATEGORY]"
                        :value="mixtureCategory"
                        :apply-warning-class="highlightCategories && applyWarningClassForMixtureOrMaterial"
                        @input="onMixtureCategoryChange"
                    />
                    <AdditionalMaterial
                        :read-only="readOnly"
                        :config="properties[types.ADDITIONAL_MATERIAL]"
                        :value="additionalMaterial"
                        :apply-warning-class="highlightCategories"
                        @input="onAdditionalMaterialChange"
                    />
                </template>
                <Exemption
                    v-if="showExemption"
                    :read-only="readOnly"
                    :value="exemption"
                    @input="onExemptionSelect"
                />
            </b-col>
        </b-row>

        <template v-else>
            <b-row>
                <b-col cols="12" :lg="showCategories ? 6 : 12">
                    <ConcentrationRange
                        :read-only="readOnly"
                        :value="concentrationRange"
                        :config="{ data: concentrationRangeOptions }"
                        :apply-warning-class="!requireConcentrationRange"
                        :required="showConcentrationRangeRequiredMarker"
                        :state="concentrationRangeState"
                        @input="onConcentrationRangeChange"
                    />
                </b-col>
                <b-col v-if="showCategories" cols="12" lg="6">
                    <MaterialCategory
                        :read-only="readOnly"
                        :apply-warning-class="highlightCategories && applyWarningClassForMixtureOrMaterial"
                        :config="properties[types.MATERIAL_CATEGORY]"
                        :value="materialCategory"
                        @input="onMaterialCategoryChange"
                    />
                </b-col>
            </b-row>
            <b-row v-if="showCategories">
                <b-col cols="12" lg="6">
                    <MixtureCategory
                        :read-only="readOnly"
                        :config="properties[types.MIXTURE_CATEGORY]"
                        :value="mixtureCategory"
                        :apply-warning-class="highlightCategories && applyWarningClassForMixtureOrMaterial"
                        @input="onMixtureCategoryChange"
                    />
                </b-col>
                <b-col cols="12" lg="6">
                    <AdditionalMaterial
                        :read-only="readOnly"
                        :config="properties[types.ADDITIONAL_MATERIAL]"
                        :value="additionalMaterial"
                        :apply-warning-class="highlightCategories"
                        @input="onAdditionalMaterialChange"
                    />
                </b-col>
            </b-row>
            <b-row v-if="showExemption">
                <b-col cols="12">
                    <Exemption
                        :read-only="readOnly"
                        :value="exemption"
                        @input="onExemptionSelect"
                    />
                </b-col>
            </b-row>
        </template>
    </div>
</template>
